import { gql } from "@apollo/client";

const GET_INVOICE_DETAILS = gql`
  query GetInvoiceDetails($stripeInvoiceId: String!) {
    invoiceDetails(stripeInvoiceId: $stripeInvoiceId) {
      stripeId
      currency
      lines {
        description
        amount
      }
      subtotal
      discountAmount
      total
    }
  }
`;

export default GET_INVOICE_DETAILS;
